import { Stack, Typography, styled } from "@mui/material"
import { newsRubricsEnum } from "../../commons"
import {
  LatestNewsItem,
  type LatestNewsItemModel,
} from "../LatestNews/LatestNewsItem"
import type { ApiDisplayNewsReferential } from "../model"

export interface SearchNewsItemProps {
  item: LatestNewsItemModel
  referential: ApiDisplayNewsReferential
}

export const NewsCardResult = ({ item, referential }: SearchNewsItemProps) => {
  const category = newsRubricsEnum[item.rubric].shortLabel

  return (
    <Stack gap={1}>
      <HeaderBox>{category}</HeaderBox>
      <LatestNewsItem item={item} referential={referential} variant="search" />
    </Stack>
  )
}

const HeaderBox = styled(Typography)(({ theme: { palette, typography } }) => ({
  fontSize: typography.pxToRem(14),
  fontWeight: 600,
  color: palette.grey[400],
}))
